export const taxRatesData = [
  {
    id: "1",
    name: "VAT",
    taxRate: 16,
    createdOn: "12 Jul 2023",
  },
  {
    id: "2",
    name: "TGST",
    taxRate: 14,
    createdOn: "17 Jul 2023",
  },
  {
    id: "3",
    name: "HST",
    taxRate: 12,
    createdOn: "23 Jul 2023",
  },
];
